/**
 * Feature toggle constants aligned with backend Features.cs
 * Pattern: {domain}.is_{feature}_enabled
 * Convention: false = old behavior, true = new behavior
 */
export const Features = {
  Debug: {
    IsPanelEnabled: 'debug.is_panel_enabled',
    IsTimeManipulationEnabled: 'debug.is_time_manipulation_enabled',
    IsPreviewFeaturesEnabled: 'debug.is_preview_features_enabled',
  },
  Auth: {
    IsMultiAccountManagementEnabled: 'auth.is_multi_account_management_enabled',
    IsFixedPasscodeGloballyEnabled: 'auth.is_fixed_passcode_globally_enabled',
    IsFixedPasscodeEnabled: 'auth.is_fixed_passcode_enabled',
  },
  Sites: {
    IsBurndownChartEnabled: 'sites.is_burndown_chart_enabled',
  },
  Dashboard: {
    IsEnabled: 'dashboard.is_enabled',
    IsSiteBurndownChartEnabled: 'dashboard.is_site_burndown_chart_enabled',
    IsUnapprovedAllocationsEnabled: 'dashboard.is_unapproved_allocations_enabled',
    IsOpenPotsEnabled: 'dashboard.is_open_pots_enabled',
  },
  Invoices: {
    IsNewInvoiceListEnabled: 'invoices.is_new_invoice_list_enabled',
  },
  Navigation: {
    IsBackgroundPreRenderEnabled: 'navigation.is_background_pre_render_enabled',
  },
  Files: {
    IsEnabled: 'files.is_enabled',
    IsEnhancedFileManagerEnabled: 'files.is_enhanced_file_manager_enabled',
  },
  Offboarding: {
    IsEnabled: 'offboarding.is_enabled',
  },
  Bookings: {
    IsBookingImagesEnabled: 'bookings.is_booking_images_enabled',
  },
  WorkActivity: {
    IsEnabled: 'work_activity.enabled',
  },
} as const;

export type FeatureKey = string;
